<template>
    <span
        :class="['l-ss-c-tag-checkbox', { 'is-checked': isChecked }]"
        @click="onToggle($event)">
        <slot></slot>
    </span>
</template>

<script>
    import { ref, watch } from '@/lib/vue-composition-api.js';

    export default {
        name: 'tag-checkbox',
        props: {
            value: Boolean,
            disabled: Boolean,
        },
        setup(props, { emit }) {
            const isChecked = ref(props.value);

            watch(() => props.value, (newValue) => {
                isChecked.value = newValue;
            });

            const onToggle = (event) => {
                if (!props.disabled) {
                    isChecked.value = !isChecked.value;
                    emit('change', { event, value: isChecked.value });
                }
            };

            return {
                isChecked,
                onToggle,
            };
        },
    };
</script>
